import React from "react";

import SmartLink from "@litres-modules/smart-link";
import { useTranslation } from "@litres-libs/i18n";
import { useAppSelector } from "@litres-core/store";
import type { IBonusProps } from "../../utils/types";
import { Tab } from "../Tab";

import styles from "./Bonus.module.scss";
import { BonusTabIcon } from "../../../static/icons/BonusTabIcon";

export const Bonus = (props: IBonusProps) => {
  const { isMobile } = props;
  const { t } = useTranslation();
  const { is_loyalty_user, bonuses_info } = useAppSelector(
    state => state.foundationUser.loyalty
  );
  const currentBonusesAmount = bonuses_info?.current_available_bonuses;

  if (isMobile) {
    return (
      <div className={styles.control}>
        <SmartLink
          type="button"
          className={styles.bonusButton}
          href="/me/bonuses/"
        >
          <div>{is_loyalty_user ? currentBonusesAmount : t("Бонусы")}</div>
          <div className={styles.icon}>
            <BonusTabIcon />
          </div>
        </SmartLink>
      </div>
    );
  }

  return (
    <Tab
      type="bonus"
      theme="purple"
      numberTitle={is_loyalty_user ? currentBonusesAmount : undefined}
    />
  );
};
